import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";

const useApplicationListing = () => {
  const { authData } = useSelector((state) => state.loginSlice);
  const [applications, setApplications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [applicationsPerPage, setApplicationsPerPage] = useState(10);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState({});
  const [loader, setLoader] = useState(false);
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const dispatch = useDispatch();

  const handleSearch = (e) => {
    let value = e.target.value;

    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9 ]*$/.test(value);

    if (!isValid) {
      return;
    }
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (e) => {
    setApplicationsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const fetchApplications = async () => {
    try {
      setLoader(true);
      let url = `${endpoint.GET_APPLICATIONS}?pageNumber=${currentPage}&pageSize=${applicationsPerPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response.data.success) {
        const applications = response.data.data;
        setApplications(applications);
        setTotalCount(response.data.data?.totalCount);
      }
    } catch (error) {
     
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 500); // Debounce delay (500ms)

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    fetchApplications();
  }, [currentPage, applicationsPerPage, debouncedTerm]);

  return {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    applications,
    totalCount,
    searchTerm,
    applicationsPerPage,
    currentPage,
    openCreateModal,
    setOpenCreateModal,
    selectedApplication,
    setSelectedApplication,
    fetchApplications,
    loader,
  };
};

export default useApplicationListing;
